import axiosInstance from "../../../utils/axiosInstance"
import { BASE_URL,API_ENDPOINT_POPULAR_COMMON_CUISINES_DATA} from "../../../utils/constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

/** API to fetch data categorywise [cuisine,dish,drink] */

const getCuisinesData = createAsyncThunk("dashboard/cuisinesData", async (data, thunkAPI) => {
    try {
      const res = await axiosInstance.post(`${BASE_URL}${API_ENDPOINT_POPULAR_COMMON_CUISINES_DATA}`, data);
      const responseData = await res.data;
      return responseData;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error?.response?.data);
    }
  });
  export { getCuisinesData };